import { emptyLayoutConfig } from 'constants/layout';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

const AUS_FINDINGS_PATH = '/aus-findings';

export const AUS_FINDINGS_ROUTING_PARAMS = {
  loanId: 'loanId',
  typeOfAus: 'typeOfAus',
  documentId: 'documentId',
};

export class LoanAusFindingsPaths {
  static loanAusFindings = new EnhancedPath(
    `${AUS_FINDINGS_PATH}/:${AUS_FINDINGS_ROUTING_PARAMS.loanId}/:${AUS_FINDINGS_ROUTING_PARAMS.typeOfAus}/:${AUS_FINDINGS_ROUTING_PARAMS.documentId}`,
  );
}

const routesConfig = {
  settings: { layout: emptyLayoutConfig },
  routes: [
    {
      path: LoanAusFindingsPaths.loanAusFindings.path,
      component: lazyWithRetry(
        () => import('app/pages/loanApplication/LoanHeaders/MainHeaderContent/AusFindings'),
      ),
      exact: true,
    },
  ],
};

export default routesConfig;
